import { new__cn as cn } from '../util';

const style = {
  listItem: cn('h-full flex-1 overflow-hidden bg-white p-2'),
  listItemTitle: cn('w-full text-headline-sm'),

  itemListContainer: cn('flex flex-col gap-1 overflow-auto py-1'),
  itemContainer: cn(
    'flex gap-1',
    'w-full px-2 py-1',
    'rounded-md!',
    'border border-white bg-white',
    'text-black',
    'cursor-pointer',

    'enabled:hover:shadow-sm ',
    'enabled:active:border enabled:active:border-tertiary-200 enabled:active:bg-tertiary-200 enabled:active:font-bold enabled:active:text-secondary-300 enabled:active:shadow-none',
    'aria-checked:border aria-checked:border-tertiary-200 aria-checked:bg-tertiary-200 aria-checked:font-bold aria-checked:text-secondary-300 aria-checked:shadow-none',

    'disabled:text-gray-300',
  ),
  itemInfo: cn('flex items-center gap-2', 'flex-1'),
  itemName: cn('text-body-xl'),
  itemNum: cn('text-body-md font-normal text-gray-500'),

  icon: cn('h-6 w-6'),
};

export default style;
